import { BehaviorSubject, Subject } from 'rxjs';
import { Input, Directive } from '@angular/core';
import { ReviewCardComponent } from './review-card.component';
import { ReviewFilter } from '../models/review-filter';
import { ReviewHelper } from '../review-helper';
import { ReviewService } from '../review.service';
import { finalize } from 'rxjs/operators';
import { HttpCommonService, LookupService, GridFilter, AuthService } from 'projects/sepidz-web-framework/src/lib/services';
import {takeUntil} from 'rxjs/operators';

@Directive()
export abstract class ReviewDataCardComponent extends ReviewCardComponent {
  protected loadingSubject = new BehaviorSubject<boolean>(false);
  public get loading$() {
    return this.loadingSubject.asObservable();
  }
  loading: boolean = false;
  @Input()
  apiName: string;
  @Input()
  systemName: string;
  @Input()
  category: string;
  @Input()
  isList: boolean;
  @Input()
  datasetList: any[] = [];
  protected constructor(
    service: ReviewService,
    protected fetchService: HttpCommonService,
    protected lookupservice: LookupService,
    protected authService: AuthService,
  ) {
    super(service);
  }

  protected abstract retrieved(data: any): void;
  protected FillFilters(filters: ReviewFilter): GridFilter[] {
    var basefilters = ReviewHelper.buildQuery(filters);
    let _filters = [];
    basefilters.filters.forEach(x => {
      if (x.Name === "StartDate")
        _filters.push(<GridFilter>{ Type: 'F', Filed: 'VoucherDate', Value: x.Value, Operator: 'gte' });
      else
        if (x.Name === "EndDate")
          _filters.push(<GridFilter>{ Type: 'F', Filed: 'VoucherDate', Value: x.Value, Operator: 'lte' });
        else
          if (x.Name === "StartNumber")
            _filters.push(<GridFilter>{ Type: 'F', Filed: 'VoucherNo', Value: x.Value, Operator: 'gte' });
          else
            if (x.Name === "EndNumber")
              _filters.push(<GridFilter>{ Type: 'F', Filed: 'VoucherNo', Value: x.Value, Operator: 'lte' });
            else
              if (x.Name.includes("Ids"))
                _filters.push(<GridFilter>{ Type: 'F', Filed: x.Name, Value: x.Value, Operator: 'contains' });
              else
                _filters.push(<GridFilter>{ Type: 'F', Filed: x.Name, Value: x.Value, Operator: 'eq' });
    });
    _filters.forEach(x => { x.Take = 1000 });
    return _filters;
  }
  protected loadItems(filter: ReviewFilter): void {
    if (!this.apiName) return;
    if (!this.loading) {
      this.loading = true;
      this.loadingSubject.next(true);
      const query = this.FillFilters(filter);
      if (this.apiName) {
        this.fetchService
          .GetFilterGrid(this.apiName, query)
          .pipe(finalize(() => this.loadingSubject.next(false)))
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe(
            result => {
              this.loading = false;
              this.retrieved(result);
            },
            error => { this.loading = false; console.log('fetch error: ' + error); }
          );
      }
    }
  }
  
}
